// skipcq: JS-W1028, JS-0128
import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';
import InputAdornment from '@mui/material/InputAdornment';

/**
 * SearchTextField
 * A reusable search text field component with loading indicator support.
 */
function SearchTextField({
  value,
  onChange,
  label = 'Search',
  loading = false,
  placeholder,
  size = 'small',
  width = '300px',
  margin = '8px 16px',
  ...otherProps
}) {
  return (
    <TextField
      label={label}
      value={value}
      onChange={onChange}
      size={size}
      placeholder={placeholder}
      style={{ width, margin }}
      InputProps={{
        endAdornment: loading ? (
          <InputAdornment position="end">
            <CircularProgress size={16} />
          </InputAdornment>
        ) : null,
      }}
      {...otherProps}
    />
  );
}

SearchTextField.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  loading: PropTypes.bool,
  placeholder: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium']),
  width: PropTypes.string,
  margin: PropTypes.string,
};

SearchTextField.defaultProps = {
  label: 'Search',
  loading: false,
  placeholder: undefined,
  size: 'small',
  width: '300px',
  margin: '8px 16px',
};

export default SearchTextField;
